document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('footer.footer');
  if (!footer) return;

  const footerSpaceElements = document.querySelectorAll('[data-footerspace]');
  if (footerSpaceElements.length === 0) return;

  const updateFooterSpace = () => {
    const footerHeight = footer.offsetHeight;
    footerSpaceElements.forEach(element => {
      element.style.paddingBottom = `${footerHeight}px`;
    });
  };

  updateFooterSpace(); // Initial update

  window.addEventListener('resize', updateFooterSpace);
});